import React from "react";
import Header from "../Header";

// Thin wrapper: reuse the main Header component but supply the underwriting logo
const HeaderWrapper = (props) => {
  const leftNode = (
    <h1>
      <img
        src={require("./../../assets/images/underwriting-logo.png")}
        alt="Underwriting Engine"
      />
    </h1>
  );

  return <Header {...props} leftNode={leftNode} isLoanUnderwrite={true} />;
};

export default HeaderWrapper;
